<template>
  <div>

    <memlist-modal size="xxl" ref="internal-todo-editor-modal">

      <FilesListModal
        ref="filesListModal"
        :task="selected_task"
        @delete_file_clicked="delete_file_clicked"
      />

      <div ref="page-container" class="page-container">
        <div ref="top-container" class="top-container">

          <ErrorPopup
            :error="error_popup_message"
          />

          <div class="left-menu" ref="navigation-drawer">
            <memlist-navigation-drawer
              :items="unlocked_sections.filter(s => s.hide_on_create ? !creating : true).map(s => ({ icon: s.icon, value: s.value, text: s.title }))"
              @clicked="on_drawer_item_click"
            >
              <template v-slot:footer-button>
                <div v-if="local_item.status === 'DONE' || local_item.status === 'WAIT' || local_item.status === 'NOT'">
                  <memlist-icon-button
                    class="mr-2 mt-4 w-100 mb-4"
                    icon="fa fa-lock"
                    :text="$t('TODO.CLOSE_TODO')"
                    variant="danger"
                    @click="close_clicked"
                  />
                  
                </div>
              </template>
            </memlist-navigation-drawer>

          </div>
          <!-- fill the rest of the width -->
          <div class="content flex-grow-1 flex-fill">
            <memlist-card class="content-card d-flex flex-column flex-fill">
              
              <a v-if="local_item.todo_id" @click.prevent="goto_url_clicked" target="_blank" class="ml-4 mt-2 legacy-link d-inline-flex align-items-center text-decoration-none">
                <span class="svg-icon svg-icon-md text-primary me-2">
                  <i class="fa fa-link color-primary"></i>
                </span>
                <span class="text-primary ml-4">{{ todo_url }}</span>
              </a>
              
              <div v-if="selected_section_name === 'info'">

                <m-row class="mt-4">
                  <m-col lg="12">
                    <memlist-text-input
                      id="text_name"
                      name="text_name"
                      :title="$t('TODO.NAME')"
                      layout="vertical"
                      v-model="local_item.name"
                    />
                  </m-col>
                </m-row>
                <m-row class="mt-4">
                  <m-col lg="12">
                    <memlist-text-input
                      id="company_name"
                      name="company_name"
                      :title="$t('TODO.COMPANY_NAME')"
                      layout="vertical"
                      :disabled="true"
                      v-model="company_name"
                    />
                  </m-col>
                </m-row>
                <m-row class="mt-4">
                  <m-col lg="12">
                    <memlist-textarea
                      
                      id="textmessage"
                      name="textmessage"
                      title="Beskrivning"
                      rows="4"
                      layout="vertical"
                      validation_type="TEXT"
                      size="lg"

                      v-model="local_item.descr"

                      placeholder="Fritext"
                      :required="false"
                    />

                  </m-col>
                </m-row>
                
              </div>

              <div v-if="selected_section_name === 'users'">
                <memlist-static-table
                  id="users-table"
                  class="mt-4"
                  :fields="users_headers"
                  :items="users"
                  ref="users-table"
                >
                
                </memlist-static-table>
              </div>

              <div v-if="selected_section_name === 'tasks'">
                <memlist-static-table
                  id="tasks-table"
                  class="mt-4"
                  :fields="tasks_headers"
                  :items="tasks"
                  ref="tasks-table"
                >
                  <template #cell(status)="data">

                    <memlist-select-input2
                      style="margin-top: 0px !important;"
                      :id="`status-${data.item.todo_task_id}`"
                      :name="`status-${data.item.todo_task_id}`"
                      layout="vertical"
                      validation_type="TEXT"
                      v-model="data.item.status"
                      :items="status_options"
                      :item="data.item"
                      :invalid_text="''"
                      :info_text="''"
                      @input="task_status_change"
                    />

                  </template>
          
                  <template #cell(actions)="data">
                    <div class='d-flex justify-content-end'>
                      <memlist-table-button class="mr-2" :notification="data.item.num_notifications" @click="show_comments_clicked(data.item.todo_task_id)" svg="/assets/svg/chat2.svg" :tooltip="$t('MEMBER_EDITOR.SHOW')" />
                    </div>
                  </template>

                </memlist-static-table>
              </div>
              <div v-if="selected_section_name === 'company_info'">
                <m-row class="mt-4">
                  <m-col lg="12">
                    <memlist-text-input
                      id="company_name"
                      name="company_name"
                      :title="$t('TODO.COMPANY_NAME')"
                      layout="vertical"
                      :disabled="true"
                      v-model="company_name"
                    />
                  </m-col>
                </m-row>
                <m-row class="mt-4">
                  <m-col lg="12">
                    <memlist-text-input
                      id="org_number"
                      name="org_number"
                      :title="$t('COMPANY.ORG_NUMBER')"
                      layout="vertical"
                      :disabled="true"
                      v-model="company.org_number"
                    />
                  </m-col>
                </m-row>
                <m-row class="mt-4">
                  <m-col lg="6">
                    <memlist-text-input
                      id="email"
                      name="email"
                      :title="$t('COMPANY.EMAIL')"
                      layout="vertical"
                      :disabled="true"
                      v-model="company.email"
                    />
                  </m-col>
                  <m-col lg="6">
                    <memlist-text-input
                      id="phone"
                      name="phone"
                      :title="$t('COMPANY.PHONE')"
                      layout="vertical"
                      :disabled="true"
                      v-model="company.phone"
                    />
                  </m-col>
                </m-row>
                
              </div>
              <div v-if="selected_section_name === 'history'">
                <TodoHistoryList
                  :histories="all_histories"
                />
              </div>

            </memlist-card>          
          </div>
        </div>

        <m-row v-if="data_was_changed">
          <m-col lg="4">

          </m-col>
          <m-col lg="8">
            <memlist-inline-alert variant="success">{{ $t('TODO.EMAIL_NOTIFICATION_WILL_BE_SENT') }}</memlist-inline-alert>
          </m-col>
        </m-row>

        <m-row>
          <m-col cols="12">
            <RightModalSaveAndCloseButtons
              :text="$t('COMMON.SAVE')"
              :spin="true"
              @clicked="on_save_clicked"
              @close="$refs['internal-todo-editor-modal'].hide()"
              ref="saveButton" />
          </m-col>
        </m-row>

      </div>

    </memlist-modal>

    <TaskChatAndFileModal
      v-if="selected_task"
      ref="task-chat-file-modal"
      @created="task_change_created"
      :task="selected_task"
      :histories="task_histories"
    />
  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';

import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { is_mobile } from '@/core/services/utils';

import ErrorPopup from '@/view/components/ErrorPopup.vue';
import FilesListModal from '@/view/pages/ml/todo/FilesListModal.vue';
import TaskChatAndFileModal from './TaskChatAndFileModal.vue';
import TodoHistoryList from './TodoHistoryList.vue';

export default {
  name: 'TodoActiveEditorModal',
  components: {
   FilesListModal,
   ErrorPopup,
   TaskChatAndFileModal,
   TodoHistoryList
  },
  props: ['todo_id'],
  emits: ['created', 'updated', 'deleted'],
  computed: {
    todo_url() {
      return get_domain_url() + `/ml-todo-wizard/${this.local_item.todo_id}`;
    },
    status_options() {
      return [ 
        { text: this.$t('TODO.STATUSES.NOT'), value: 'NOT' },
        { text: this.$t('TODO.STATUSES.DONE'), value: 'DONE' },
        { text: this.$t('TODO.STATUSES.CLOSE'), value: 'CLOSE' },  
      ]
    },
    company_name() {
      return this.local_item.company ? this.local_item.company.name : '-';
    },
    ...mapGetters(['selected_shop_item_id', 'currentCompanyId', 'currentPeriodId', 'currentUserId', 'companies', 'periods', 'profile', 'settings','isTHS', 'sid']),
    creating() {
      return !this.local_item || !this.local_item.todo_id;
    },
    is_mobile() {
      return is_mobile();
    },
    selected_section_name() {
      if (this.selected_item === undefined) {
        return '';
      }

      if (this.unlocked_sections[this.selected_item] === undefined) {
        return '';
      }

      return this.unlocked_sections[this.selected_item].name;
    }
  },
  mixins: [ toasts ],
  watch: {
    
    todo_id: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {

        this.local_item = {}; // Clear the current local_item to prevent leftover state

        this.$nextTick(() => {
          if (this.todo_id) {
            this.load_todo(this.todo_id);
          } else {
            this.local_item = { name: 'Nytt ärende' };
          }
        });
      },
      immediate: true
    },
  },
  mounted() {
    if (is_mobile()) {
      this.mini = true;
    }

  },
  methods: {

    createTodo() {
      
    },

    delete_file_clicked(file) {
      console.log('file deleted clicked');
    },
    async task_change_created(data) {
      this.task_histories = await this.fetch_task_histories(this.selected_task.todo_task_id);
    },
    async send_comment_clicked() {
      try {
        const res = await axios.post(`/todo_task/comment/${this.todo_task_id}`, {
          from: 'top',
          is_top: true,
          comment: this.comment,
          todo_task_id: this.todo_task_id
        });

        if (res.status === 201) {
          this.comment = '';
          this.comments.push(res.data);
          this.load_todo(this.todo_id);
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte skicka kommentar');
        }
      }
      catch (err) {
        console.error('send_comment_clicked error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte skicka kommentar');
      }
    },

    async task_status_change(value, item) {
      this.data_was_changed = true;
      const index = this.tasks.findIndex(i => i.todo_task_id === item.todo_task_id);
      this.tasks[index] = item;

      console.log('task_status_change', value, item);

      await this.update_task(item);
    },

    async update_task(task) {
      try {
        const res = await axios.put(`/todo_task/${task.todo_task_id}`, task);

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.TASK_UPDATED'));
          return;
        }
      }
      catch (err) {
        console.error('update_task error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_UPDATE_TASK'));
    },
    
    goto_url_clicked() {
      window.open(this.todo_url, '_blank')
    },
    async close_clicked() {
      
      try {
        this.local_item = { ...this.local_item, status: 'CLOSE' };

        // this is the row that triggeres the error, when when we comment out the this.on_save_clicked()
        this.$nextTick(async ()=>{
          await this.on_save_clicked();
        });
      }
      catch (err) {
        console.error('close_clicked error', err);
      }
    },

    async on_save_clicked() {

      if (this.local_item.todo_id) {
        this.update_todo(this.local_item);
      }

      this.$nextTick(async ()=>{
        this.$refs['saveButton'].stop();
      });
    },


    async put_todo(todo, tasks) {
      try {
        const res = await axios.put(`/todo/${todo.task_id}`, {
          ...todo,
          tasks
        });

        if (res.status === 403) {
          this.error_popup_message = 'ERR_FORBIDDEN';

          this.$nextTick(()=>{ this.error_popup_message = null; });
          return;
        }

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.UPDATED'));
        }
      }
      catch (err) {
        console.error('');
      }
    },

    async fetch_task_histories(todo_task_id) {
      try {
        const res = await axios.get(`/todo_task/${todo_task_id}`);

        if (res.status === 200) {
          return res.data.histories;
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta kommentarer');
        }
      }
      catch (err) {
        console.error('comments error', err);
      }

      return []
    },

    async show_comments_clicked(todo_task_id) {
      try {
        this.todo_task_id = todo_task_id;
        const res = await axios.get(`/todo_task/${todo_task_id}`);

        if (res.status === 200) {
          this.selected_task = res.data;
          this.task_histories = res.data.histories;
          
          this.comments = res.data.comments;
          
          this.$nextTick(()=>{
            this.$refs['task-chat-file-modal'].show();
          });
          
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta kommentarer');
        }
      }
      catch (err) {
        console.error('comments error', err);
      }
    },

    
    show() {
      this.selected_item = 0;
      this.$refs['internal-todo-editor-modal'].show();
    },
    hide() {
      this.$refs['internal-todo-editor-modal'].hide();
    },
    on_drawer_item_click({ index, value, text }) {
      this.selected_item = index
      this.list_item_group_change(index);
    },
    
    get_unlock_section_fields_by_name(name) {
      const obj = this.shown_settings_data.find(item => item.name === name);

      if (obj === undefined) {
        return [];
      }

      return obj.children;
    },

    has_unlocked_section(name) {
      const unlock = this.shown_settings_data.find(item => item.name === name);

      return unlock !== undefined && unlock.value;
    },

    async load_history(todo_id) {
      try {
        const response = await axios.get(`/todo/${todo_id}/history`);

        if (response.status === 200) {
          this.all_histories = response.data;
        }
      }
      catch (err) {
        console.error('load_history error', err);
      }
    },

    async load_users(company_id) {
      try {
        const res = await axios.get(`/user/company/${company_id}`);

        if (res.status === 200) {
          this.users = res.data;
        }
      }
      catch (err) {
        console.error('load_users', err);
      }
    },

    async load_todo(todo_id) {
      try {
      
        const response = await axios.get(`/todo/${todo_id}`);

        if (response.status === 200) {
          this.local_item = response.data;
          this.company = response.data.company;
          this.tasks = this.local_item.tasks;
          
          console.log('local_item', this.local_item);

          this.load_history(todo_id);
          this.load_users(this.company.company_id);
          return true;
        }

        console.error('unable to get todo', response.status);

      }
      catch (err) {
        console.error('load_todo', err);
      }

      return null;
    },

    async update_todo(todo) {
      try {

        const res = await axios.put(`/todo/${todo.todo_id}`, {
          ...todo,
          company_id: this.currentCompanyId,
          period_id: this.currentPeriodId });

        if (res.status === 403) {
          this.error_popup_message = 'ERR_FORBIDDEN';

          this.$nextTick(()=>{ this.error_popup_message = null; });
          return;
        }

        if (res.status !== 200) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_UPDATE'));
          console.error('unable to update event', res.status);
          return;
        }
        else {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.UPDATED'))
        }

        this.$emit('updated', res.data);
      }
      catch (err) {
        console.error(`update_todo error: ${err}`)
      }

      this.$refs['saveButton'].stop();
    },

    async delete_todo(todo_id) {

      try {

        const res = await axios.delete(`/todo/${todo_id}`);

        if (res.status === 403) {
          this.error_popup_message = 'ERR_FORBIDDEN';

          this.$nextTick(()=>{ this.error_popup_message = null; });
          return;
        }

        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TODO.DELETED'));
          this.clear();
          this.$emit('deleted', member_id);
          return;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_DELETE'));
      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TODO.UNABLE_DELETE'));
        console.error(err);
      }
    },

    toggle_mini() {
      if (is_mobile()) {
        this.mini = true;
        return;
      }

      this.mini = !this.mini;
    },

    list_item_group_change() {
      if (is_mobile()) {
        this.mini = true;
      }
    },

    clear() {

      this.local_item = {};
    },


  },
  data() {
    return {
      all_histories: [],
      task_histories: [],
      company: {},
      todo_task_id: null,
      data_was_changed: false,
      selected_task: null,
      comments: [],
      tasks: [],
      error_popup_message: null,
      waiting_for_status: false,
      mini: false,

      local_item: {

      },

      // which fields to show
      shown_settings_data: [],

      content_style: null,
      bottom_search_style: null,

      drawer: false,
      selected_item: 0,

      all_sections: [
        { title: this.$t('TODO.TASKS'), icon: 'mdi-calendar', name: 'tasks', hide_on_create: false },
        { title: this.$t('TODO.BASIC'), icon: 'mdi-calendar-text', name: 'info', hide_on_create: false },
        { title: this.$t('TODO.USERS'), icon: 'mdi-account-circle', name: 'users', hide_on_create: false },
        { title: this.$t('TODO.COMPANY'), icon: 'mdi-bank', name: 'company_info', hide_on_create: true },
        { title: this.$t('TODO.HISTORY'), icon: 'mdi-history', name: 'history', hide_on_create: true },
      ],


      // the final list of sections to show
      unlocked_sections: [
        { title: this.$t('TODO.TASKS'), icon: 'mdi-calendar', name: 'tasks', hide_on_create: false },  
        { title: this.$t('TODO.BASIC'), icon: 'mdi-calendar-text', name: 'info', hide_on_create: false },
        { title: this.$t('TODO.USERS'), icon: 'mdi-account-circle', name: 'users', hide_on_create: false },
        { title: this.$t('TODO.COMPANY'), icon: 'mdi-bank', name: 'company_info', hide_on_create: true },
        { title: this.$t('TODO.HISTORY'), icon: 'mdi-history', name: 'history', hide_on_create: true },
      ],

      history: [],

      users: [],
      users_headers: [
        { 
          tdClass: 'td-overflow',
          thClass: 'td-overflow',
          label: 'Namn',
          key: 'firstname',
          formatter: (_, __, item) => {
            return (item.firstname || '') + ' ' + (item.lastname || '');
          }
        },
        { 
          tdClass: 'td-overflow',
          thClass: 'td-overflow',
          label: 'E-post',
          key: 'email'
        },
        { 
          label: '', 
          key: 'actions',
          thClass: 'td-short4', 
          tdClass: 'td-short4', 
        },
      ],

      history_headers: [
        { 
          tdClass: 'td-overflow3',
          thClass: 'td-overflow3',
          label: 'Åtgärd',
          key: 'name' 
        },
        { 
          thClass: 'td-short4', 
          tdClass: 'td-short4',
          label: 'Typ',
          key: 'type' 
        },
        { 
          label: 'Uppdaterad', 
          key: 'created_at',
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD HH:mm');
          } 
        },
      ],
      tasks_headers: [
        { 
          tdClass: 'td-overflow3',
          thClass: 'td-overflow3',
          label: 'Åtgärd',
          key: 'name' 
        },
        { 
          thClass: 'td-short5', 
          tdClass: 'td-short5',
          label: 'Status', 
          key: 'status' 
        },
        { 
          label: 'Uppdaterad', 
          key: 'updated_at',
          formatter: (_, __, item) => {
            return dayjs(item.updated_at).format('YYYY-MM-DD HH:mm');
          } 
        },
        { 
          label: '', 
          key: 'actions',
          thClass: 'td-short4', 
          tdClass: 'td-short4', 
        },
      ]
    }
  },
}

</script>

<style lang="scss" scoped>


.row {
  margin-top: -12px !important;
}

.page-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.fill-rest {
  flex: 1 1 auto;
}


.quick-search-card {
  overflow: scroll;
}

.selected-item-active {
  border-radius: 4px;
  background: #f4fcff;
  color: black;
}

.card-title {
  background-color:#f7f7f7;
  border-bottom:1px solid #dedede;
  padding-bottom: 15px;

}

.card-title-p {
  margin-bottom: 8px !important;
  margin-top: 7px !important;
}


.top-container {
  display: flex;
}

.content {
  flex-grow: 1;
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-left: 8px !important;
}



.drawer-header {
  margin-bottom: -13px !important;
}

.drawer {
  border-right: 1px solid #dddddd !important;
}

.fixed-font {
  font-size: 0.95rem !important;
  font-weight: 500;
  line-height: 1rem;
}

:deep .v-application--wrap {
  min-height: 0px !important;
}

.legacy-link:hover {
  cursor: pointer;
}

</style>
